/**
 * TrustBadge — the single visual for the REVIEWED / AI MATCH / AI EXTRACT
 * trust ladder (see utils/designTrust.js). Green = a human confirmed it;
 * amber = machine output, check it against the source document on the left.
 *
 * Used both as an overlay on the matched product photo and inline on the
 * recipe card, so the designer sees one consistent trust signal.
 */
import React from 'react';
import { Check, AlertCircle } from 'lucide-react';

const TONES = {
  green: { wrap: 'bg-emerald-100 text-emerald-700 border-emerald-300', Icon: Check },
  amber: { wrap: 'bg-amber-100 text-amber-800 border-amber-300', Icon: AlertCircle },
};

export default function TrustBadge({ state, className = '' }) {
  if (!state) return null;
  const tone = TONES[state.tone] || TONES.amber;
  const Icon = tone.Icon;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${tone.wrap} ${className}`}
      data-testid={`trust-badge-${state.key}`}
    >
      <Icon className="h-3 w-3" />
      {state.label}
    </span>
  );
}
